import { filter } from "lodash";

import { regulationsChanged, regulationNameChanged } from "../../actions/filters";
import makeGroupedMultiSelect from "../../../../shared/make_grouped_multi_select";

const valuesSelector = (state) => state.filters.regulations.selectedValues;
// eslint-disable-next-line
const optionsSelector = (state) => (state.filters.showOnlyRegulationsWithNumericalStandards === "checked" ? filter(state.filters.regulations.options, e => e.disabled || e.has_numerical_standards) : state.filters.regulations.options);
const initialTextValueSelector = (state) => state.filters.regulationName;

export default makeGroupedMultiSelect(regulationsChanged, "Regulation names", valuesSelector, optionsSelector, { clearable: true, placeholder: "Filter by regulation" }, { "col-md-6": true }, regulationNameChanged, initialTextValueSelector);
